import React from "react";
import { Field } from "redux-form";
import Select from "react-select";
import { icons } from "icons";
import "./camposInventario.css";

// 1. DEFINIR FUERA PARA EVITAR BUCLES INFINITOS
const required = value => (value || typeof value === 'number' ? undefined : 'Este campo es requerido');

const renderField = ({ input, label, type, step, meta, readOnlyMode }) => {
    const hasError = meta && meta.touched && meta.error;

    return (
        <div className="form-group">
            {/* Si pasas la prop label al Field, la usamos aquí */}
            {label && <label>{label} *</label>}
            <input 
                {...input} 
                type={type} 
                step={step}
                readOnly={readOnlyMode} 
                className={`
                    form-control
                    ${hasError ? "is-invalid" : ""}
                    ${readOnlyMode ? "input-readonly" : ""}
                `}
            />
            {hasError && (
                <span className="text-danger" style={{ fontSize: "12px" }}>
                    {meta.error}
                </span>
            )}
        </div>
    );
};

export const inventarioInicialFields = ({
    fields,
    sucursales,
    readOnlyMode = false
}) => {

    const currentFields = fields.getAll() || [];
    const selectedSucursalIds = currentFields.map((item) => item && item.sucursal);

    const sucursalesDisponibles = sucursales 
        ? sucursales.filter((sucursal) => selectedSucursalIds.indexOf(sucursal.id) === -1) 
        : [];

    React.useEffect(() => {
        // Solo agregamos si está vacío para evitar bucles con el push inicial
        if (!readOnlyMode && fields.length === 0 && sucursales && sucursales.length > 0) {
            fields.push({
                sucursal: sucursales[0].id,
                datos_sucursal: sucursales[0],
                existencias: "",
                costo_compra: ""
            });
        }
    }, [sucursales]); // Quitamos 'fields' de las dependencias para mayor seguridad

    return (
        <div className={readOnlyMode ? "read-only-wrapper w-100" : "w-100"}>

            <div className="w-100 row mt-2 mb-3">
                <div className="col-12 col-md-6 col-lg-3">

                    {!readOnlyMode && (
                        <Select
                            className="form-control"
                            placeholder="Seleccione la sucursal"
                            options={sucursalesDisponibles}
                            valueKey="id"
                            labelKey="nombre"
                            onChange={(value) => {
                                if (value) {
                                    fields.push({
                                        sucursal: value.id,
                                        datos_sucursal: value,
                                        existencias: "",
                                        costo_compra: ""
                                    });
                                }
                            }}
                        />
                    )}
                </div>
            </div>

            {fields.map((item, index) => {
                const sucursalItem = fields.get(index);

                return (
                    <div key={index} className="card p-3 mb-3">
                        <Field
                            name={`${item}.sucursal`}
                            component="input"
                            type="hidden"
                        />

                        <div className="d-flex justify-content-between align-items-center mb-2">
                           <strong>
                                {sucursalItem && sucursalItem.datos_sucursal
                                    ? sucursalItem.datos_sucursal.nombre
                                    : ""}
                            </strong>
                            {!readOnlyMode && (
                                <img
                                    onClick={() => fields.remove(index)}
                                    className="action-img"
                                    title="Eliminar"
                                    src={icons.eliminar}
                                    alt="Eliminar"
                                    style={{ cursor: "pointer" }}
                                />
                            )}
                        </div>

                        <div className="row">
                            <div className="col-md-6 form-group">
                                <Field
                                    name={`${item}.existencias`}
                                    component={renderField}
                                    type="number"
                                    label="Existencias"
                                    validate={[required]}
                                    readOnlyMode={readOnlyMode}
                                />
                            </div>

                            <div className="col-md-6 form-group">
                                <Field
                                    name={`${item}.costo_compra`}
                                    component={renderField}
                                    type="number"
                                    step="0.01"
                                    label="Precio compra"
                                    validate={[required]}
                                    readOnlyMode={readOnlyMode}
                                />
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};